import isString from "lodash/isString";
import { Flex, Grid } from "@jutro/layout";
import { log } from "@jutro/logger";
var layoutComponentMap = {
  flex: Flex,
  grid: Grid,
  div: "div",
  Flex: Flex,
  Grid: Grid
};
export var getLayoutComponent = function (component) {
  return isString(component) ? layoutComponentMap[component] || layoutComponentMap.div : component;
};
export function getModalRoot() {
  if ("undefined" == typeof document) return null;
  var modalRoot = document.getElementById("modalRoot");
  if (modalRoot) return modalRoot;
  var deprecatedModalRoot = document.getElementById("confirmation");
  return deprecatedModalRoot ? (log.warning('ModalNextProvider: Found deprecated <div id="confirmation">. Please use <div id="modalRoot"> instead.'), deprecatedModalRoot) : (log.warning('ModalNextProvider: Unable to find <div id="modalRoot">. Please add at the bottom of the <body> in your index.html.'), document.body);
}